
import { AppTable } from '@/components';
import type { LiveopsMilestoneReward } from '@/modules/liveops/milestone/types';
import { computed, defineComponent, PropType } from 'vue';
import { RewardFeatures } from '@/common/reward/types';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: 'LiveopsMilestoneTable',
    components: { AppTable },
    props: {
        rows: { type: Array as PropType<LiveopsMilestoneReward[]>, required: true },
        total: { type: Number, default: undefined },
        canEdit: { type: Boolean, default: false },
        onRemove: { type: Function as PropType<(milestone: number) => void>, default: undefined },
        onRefresh: { type: Function as PropType<() => void>, default: undefined }
    },
    setup(props) {
        const table: TableConfig<LiveopsMilestoneReward> = {
            columns: [
                { type: TableColumnType.Text, label: 'Milestone', key: 'milestone' },
                { type: TableColumnType.Text, label: 'Point cap', key: 'pointCap' },
                { type: TableColumnType.Option, label: 'Feature', key: 'feature', options: RewardFeatures },
                { type: TableColumnType.RouterLink, label: 'Item', key: 'itemName', to: row => row.itemLink ?? '' },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: LiveopsMilestoneReward) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !props.canEdit,
                        onClick: () => props.onRemove?.(row.milestone)
                    })
                }
            ]
        };

        const totalRows = computed(() => props.total ?? props.rows.length);

        return { table, totalRows };
    }
});
